/** Ordenen- en Backlog-introkaarten via de gedeelde onboarding-hintwachtrij. */
import { useT } from '@/i18n/useT';
import {
  ONBOARDING_HINT_BACKLOG_INTRO,
  ONBOARDING_HINT_ORGANIZE_INTRO,
} from '@/constants/onboardingHints';
import { ONBOARDING_HINT_QUEUE_PRIORITIES } from '@/features/onboarding/constants/onboardingHintQueue';
import { useRegisterOnboardingQueuedHint } from '@/features/onboarding/context/useRegisterOnboardingQueuedHint';
import { useBacklogIntroHint } from '@/features/organize/hooks/use-backlog-intro-hint';
import { useOrganizeIntroHint } from '@/features/organize/hooks/use-organize-intro-hint';

const OrganizeIntroHints = ({ activeTabKey, userId }) => {
  const t = useT();
  const isActiveTab = activeTabKey === 'active';
  const isBacklogTab = activeTabKey === 'backlog';

  const { showHint: showOrganizeHint, dismissHint: dismissOrganizeHint } =
    useOrganizeIntroHint({ isActiveTab, userId });
  const { showHint: showBacklogHint, dismissHint: dismissBacklogHint } =
    useBacklogIntroHint({ isBacklogTab, userId });

  const organizeTitle = t(
    'onboarding.organizeIntro.title',
    'Hier werk je taken uit en breng je structuur aan.',
  );
  const organizeBody = t(
    'onboarding.organizeIntro.body',
    'Sleep taken om de volgorde te wijzigen (of gebruik Ctrl+↑↓). Selecteer een taak om rechts subtaken toe te voegen en details in te vullen.',
  );
  const backlogTitle = t(
    'onboarding.backlogIntro.title',
    'Taken in de Backlog verdwijnen uit beeld tot je er weer tijd voor hebt.',
  );
  const backlogBody = t(
    'onboarding.backlogIntro.body',
    'Je zet een taak erin via de taakdetails.',
  );

  useRegisterOnboardingQueuedHint({
    id: ONBOARDING_HINT_ORGANIZE_INTRO,
    priority:
      ONBOARDING_HINT_QUEUE_PRIORITIES[ONBOARDING_HINT_ORGANIZE_INTRO],
    eligible: showOrganizeHint,
    pending: showOrganizeHint,
    title: organizeTitle,
    body: organizeBody,
    testId: 'organize-intro-hint',
    onDismiss: dismissOrganizeHint,
  });

  useRegisterOnboardingQueuedHint({
    id: ONBOARDING_HINT_BACKLOG_INTRO,
    priority:
      ONBOARDING_HINT_QUEUE_PRIORITIES[ONBOARDING_HINT_BACKLOG_INTRO],
    eligible: isBacklogTab && showBacklogHint,
    pending: showBacklogHint,
    title: backlogTitle,
    body: backlogBody,
    testId: 'backlog-intro-hint',
    onDismiss: dismissBacklogHint,
  });

  return null;
};

export default OrganizeIntroHints;
